import { CommonEnums } from '../../common.enums';
export class Transform_Inst {


    dxMp_Id: number;
    transform_Inst_Id: number;
    nm: string;
    scriptNm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    persistFlg: string;
    updateDt: Date;
    updateBy: string;
    lastUpdateBy: string;
    prop_Tab_Valid_Cd: string;
    in_Attr_Tab_Valid_Cd: string;
    out_Attr_Tab_Valid_Cd: string;

    /** forceReConnFlg flag has 'Y' or 'N' values, by default it will be 'N' and if already session exists 
        * for that User, then we have to set 'Y', to login forciabilly.
       */
    forceReConnFlg: string;
    ssoFlg: string;
    flag: string;
    type: string;
    static input_Inst_Id: number;

    constructor() {
        this.setDefaults()
    }
    setDefaults() {

        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.transform_Inst_Id = CommonEnums.defaults.LONG_VAL
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.scriptNm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.persistFlg = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.prop_Tab_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.in_Attr_Tab_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.out_Attr_Tab_Valid_Cd = CommonEnums.defaults.STRING_EMPTY;

    }
    copy(): Transform_Inst {
        let tansform_instTmp: Transform_Inst = new Transform_Inst();

        tansform_instTmp.dxMp_Id = this.dxMp_Id;
        tansform_instTmp.transform_Inst_Id = this.transform_Inst_Id;
        tansform_instTmp.nm = this.nm;
        tansform_instTmp.scriptNm = this.scriptNm;
        tansform_instTmp.description = this.description;
        tansform_instTmp.ver = this.ver;
        tansform_instTmp.valid_Cd = this.valid_Cd;
        tansform_instTmp.persistFlg = this.persistFlg;
        tansform_instTmp.updateDt = this.updateDt;
        tansform_instTmp.updateBy = this.updateBy;
        tansform_instTmp.lastUpdateBy = this.lastUpdateBy;
        tansform_instTmp.prop_Tab_Valid_Cd = this.prop_Tab_Valid_Cd;
        tansform_instTmp.in_Attr_Tab_Valid_Cd = this.in_Attr_Tab_Valid_Cd;
        tansform_instTmp.out_Attr_Tab_Valid_Cd = this.out_Attr_Tab_Valid_Cd;

        return tansform_instTmp;
    }
    copyFrom( tansform_instTmp: Transform_Inst ): void {

        this.dxMp_Id = tansform_instTmp.dxMp_Id;
        this.transform_Inst_Id = tansform_instTmp.transform_Inst_Id;
        this.nm = tansform_instTmp.nm;
        this.scriptNm = tansform_instTmp.scriptNm;
        this.description = tansform_instTmp.description;
        this.ver = tansform_instTmp.ver;
        this.valid_Cd = tansform_instTmp.valid_Cd;
        this.persistFlg = tansform_instTmp.persistFlg;
        this.updateDt = tansform_instTmp.updateDt;
        this.updateBy = tansform_instTmp.updateBy;
        this.lastUpdateBy = tansform_instTmp.lastUpdateBy;
        this.prop_Tab_Valid_Cd = tansform_instTmp.prop_Tab_Valid_Cd;
        this.in_Attr_Tab_Valid_Cd = tansform_instTmp.in_Attr_Tab_Valid_Cd;
        this.out_Attr_Tab_Valid_Cd = tansform_instTmp.out_Attr_Tab_Valid_Cd;

    }
    compare( tansform_instTmp: Transform_Inst ) {

        let tansform_inststring: string = toString();
        let tansform_instTmpstring: string = tansform_instTmp.toString();

        if (tansform_inststring != tansform_instTmpstring) {
            return tansform_inststring + ',' + tansform_instTmpstring
        }
        return '';

    }
    toString(): string {

        return "Transform_Inst[dxMp_Id=" + this.dxMp_Id +
            ",transform_Inst_Id=" + this.transform_Inst_Id +
            ",nm=" + this.nm +
            ",scriptNm=" + this.scriptNm +
            ",description=" + this.description +
            ",ver=" + this.ver +
            ",valid_Cd=" + this.valid_Cd +
            ",persistFlg=" + this.persistFlg +
            ",updateDt=" + this.updateDt +
            ",updateBy=" + this.updateBy +
            ",lastUpdateBy=" + this.lastUpdateBy +
            ",prop_Tab_Valid_Cd=" + this.prop_Tab_Valid_Cd +
            ",in_Attr_Tab_Valid_Cd=" + this.in_Attr_Tab_Valid_Cd +
            ",out_Attr_Tab_Valid_Cd=" + this.out_Attr_Tab_Valid_Cd +
            ",]";
    }

}